export enum Limits {
  // Default
  MAX_SHORT_TEXT = 50,
  MAX_LINK = 500,

  // User
  MIN_USER_PASSWORD_LENGTH = 6,
  MAX_USER_FIRST_NAME = 50,
  MAX_USER_LAST_NAME = 100,
  MAX_AVATAR = 2 * 1024 * 1024, // 2MB
  MAX_USER_LINK = 500,
  MAX_USER_TITLE = 500,
  MAX_USER_BIO = 1500,

  // Project
  MAX_PROJECT_NAME = 50,
  MAX_PROJECT_DESCRIPTION = 500,

  // Offer
  MAX_OFFER_NAME = 100,
  MAX_OFFER_TYPE = 50,
  MAX_OFFER_PROBLEM = 300,
  MAX_OFFER_PROMISE = 300,
  MAX_OFFER_PRICE = 50,
  MAX_OFFER_DESCRIPTION = 1000,
  MAX_OFFER_LIST_ITEM = 200,

  // Client avatar (inline edit caps, by field nature)
  MAX_AVATAR_SHORT_TEXT = 100,
  MAX_AVATAR_SENTENCE = 300,
  MAX_AVATAR_PARAGRAPH = 600,
  MAX_AVATAR_LIST_ITEM = 200,

  // Messages & sequences
  MAX_SEQUENCE_STEPS = 10,
  MAX_ADMIN_CREDITS_GRANT = 10000,
  MAX_SEQUENCE_STEP_NAME = 50,
  MAX_SEQUENCE_TEMPLATE = 2000,
  MAX_SEQUENCE_AI_RULES = 500,
  MAX_SEQUENCE_OBJECTIVES = 5,
  MAX_SEQUENCE_OBJECTIVE_LABEL = 120,
  MAX_SEQUENCE_OBJECTIVE = 300,
  MAX_SEQUENCE_STEP_VARIANTS = 3,

  MAX_SCRIPT_QUESTIONS = 15,
  MAX_SCRIPT_OBJECTIONS = 15,
  MAX_SCRIPT_BLOCK_BODY = 2000,
  MAX_SCRIPT_ITEM_LABEL = 300,
  MAX_SCRIPT_ITEM_RESPONSE = 600,
  MAX_SEQUENCE_VARIANT_LABEL = 50,
  MAX_SEQUENCE_DELAY_DAY = 365,
  MAX_SEQUENCE_DELAY_HOUR = 720,
  MAX_SEQUENCE_DELAY_MINUTE = 1440,
  MAX_PROJECT_OFFERS = 5,
  MAX_PROJECT_AVATARS = 3,
  MAX_PROJECT_MEMBERS = 10,

  MAX_REPLY_THREAD_MESSAGES = 20,
  MAX_REPLY_THREAD_MESSAGE = 2000,
  MAX_REPLY_SUGGESTION = 1200,
  MAX_REPLY_INSTRUCTION = 400,
  MAX_REPLY_DRAFT = 4000,
  MAX_CONVERSATION_SUMMARY = 1500,

  // Prospect search (search queries + signal criteria items)
  MAX_PROSPECT_STRATEGY_VALUE = 300,

  // Prospect actions (the CRM history of a qualified prospect)
  MAX_PROSPECT_ACTION_LABEL = 50,
  MAX_PROSPECT_ACTION_NOTE = 300,
  MAX_PROSPECT_ACTIONS = 100,
  MAX_PROSPECT_ROW_ACTIONS = 20,
  MAX_PROJECT_PROSPECT_ACTION_TYPES = 10,

  // MCP input caps (what a connected AI may write through the MCP tools)
  MAX_MCP_SHORT_TEXT = 300,
  MAX_MCP_LONG_TEXT = 3000,
  MAX_MCP_LIST_ITEM = 500,
  MAX_MCP_TIMELINE_TIME = 100,
  MAX_MCP_TIMELINE_TEXT = 1000,
  MAX_MCP_ARRAY_INPUT = 50,
  MAX_MCP_CALL_IDS = 50,

  // Company
  MAX_COMPANY_MEMBERS = 10,
  MAX_CREDIT_SHARE_PERCENT = 100,

  // Call
  MAX_CALL_TITLE = 255,
  MAX_CALL_TYPE = 50,
  MAX_CALL_SIGNAL_LABEL = 200,
  MAX_CALL_SIGNAL_DESCRIPTION = 600,
  MAX_CALL_SIGNAL_QUOTE = 1000,
  MAX_PROJECT_CUSTOM_CALL_TYPES = 10,
  MAX_CALL_NOTE = 500,
  MAX_CALL_FILES_PER_UPLOAD = 3,
  MAX_CALL_FILE_SIZE = 1024 * 1024 * 1024, // 1GB

  // Social connections (server cap; the extension chunks requests well below this)
  MAX_IMPORTED_PROFILES_BATCH = 200,

  // LinkedIn profile text sent by the extension for prospect extraction. Capped keeping
  // the head (topcard, about, a sample of the activity feed) and the tail (experience,
  // skills, education, languages and the appended contact block), dropping only the bulk
  // of the noisy activity feed in the middle.
  MAX_PROFILE_RAW_TEXT = 50000,
  MAX_PROFILE_RAW_TEXT_TAIL = 20000,

  POPOVER_VIEWPORT_GAP = 8,

  // Sidebar
  SIDEBAR_TOOLTIP_GAP = 16,
  SIDEBAR_PREFETCH_DELAY = 150,
  SIDEBAR_MOBILE_MAX_WIDTH = 1080,
  BRAND_LOGO_PREVIEW = 96,

  // Loaders
  FORMS_LOADER_DELAY = 300,
  ROUTE_LOADER_DELAY = 400,
  CALL_ANALYSIS_LOADER_DELAY = 500,
  CLIENT_AVATAR_LOADER_DELAY = 300,
  PROSPECT_SEARCH_LOADER_DELAY = 300,

  MAX_LINKEDIN_FEED_MEMBERS = 400,

  SAVED_FEEDBACK_DELAY = 2500,
}
